
import _ from 'lodash'
import { makeCategoryTree } from '@/feature/search/utils'

export default {
  props: {
    categoryData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    checkedList: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  emits: ['changed-category'],
  setup (_props, { emit }) {
    const fireCagetorySelectedChangeEvent = value => emit('changed-category', value)

    return {
      fireCagetorySelectedChangeEvent,
    }
  },
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    }
  },
  computed: {
    _data () {
      const { data } = this.categoryData
      return makeCategoryTree(data)
    },
    selectedCategory () {
      return _.chain(this.checkedList).filter(chk => chk.onlyOne).map(chk => chk.id).value()
    },
  },
  methods: {
    renderContent (
      h,
      { data }
    ) {
      return h(
        'span',
        {
          class: 'custom-tree-node',
        },
        [
          h(
            'span',
            {
              class: 'name'
            },
            data.label,
          ),
          h(
            'span',
            null,
            ' '
          ),
        ]
      )
    },
    sync () {
      const { label, value, ...rest } = this.getCurrentNode()
      this.fireCagetorySelectedChangeEvent({
        name: label,
        onlyOne: true, // 카테고리는 단일 선택만 가능
        count: value,
        ...rest,
      })
    },
    getCurrentKey () {
      return this.$refs.tree.getCurrentKey()
    },
    getCurrentNode () {
      return this.$refs.tree.getCurrentNode()
    },
    resetChecked () {
      this.$refs.tree.setCheckedKeys([])
    }
  }
}
